<!-- 停检单 申诉 -->
<template>
  <h-inspection-page :title="h_i18n('0addf9d81daedc6979addd92d00e46c1')+data.title" :ction-update="changeMethod" class="rejectsStop_reportTable_style">
    <form-header :title="h_i18n('4d8b6d7b890f088e863577a6608e3678')" title-height="80px" class="top_wrap_style2" title-width="5">
      <template #title>
        <h-p align="left" :title="h_i18n('4ff1e74e43a3586339251494117185ad')" class="source_style" style="line-height:32px;border-bottom:1px solid #ccc;width: 99%;">{{ time(new Date()) }}</h-p>
        <h-p align="left" :title="h_i18n('4850ea222f13bd23bec1cdace19cb633')" class="source_style" style="line-height:32px;">{{ getData.stopCheckId }}</h-p>
      </template>
      <template #body>
      </template>
    </form-header>

    <div class="top_style">
      <div class="ground_style">
        <div class="top_left">
          <table class="table-box-bordered" cellspacing="0">
            <colgroup class="top_left_table_title"></colgroup>
            <colgroup class="top_left_table_content"></colgroup>
            <colgroup class="top_left_table_title"></colgroup>
            <colgroup class="top_left_table_content"></colgroup>
            <tr>
              <td>{{ h_i18n('7db20e2cb4a6a190a765a8b512b025db') }}</td>
              <td>{{ h_i18n('0addf9d81daedc6979addd92d00e46c1') }}</td>
              <td>{{ h_i18n('9221bb10f861e20c96971b87cff33aec') }}</td>
              <td class="line-td-style">{{getData.stopCheckId}}</td>
            </tr>
            <tr>
              <td>{{ h_i18n('7c7fefb36371a5a9ab5338c98790c67c') }}</td>
              <td>{{getData.mtlNo}}</td>
              <td>{{ h_i18n('7a0ae7305076f170b4a920ef5f3f04f9') }}</td>
              <td class="line-td-style">{{getData.mtlName}}</td>
            </tr>
            <tr>
              <td>{{ h_i18n('15be0cbf984ead7733f52bbd01db11a2') }}</td>
              <td>{{getData.supplyCode}}</td>
              <td>{{ h_i18n('eb0e130294c8c3b3fa2cfecc849fec49') }}</td>
              <td class="line-td-style">{{getData.supplyName}}</td>
            </tr>
            <tr>
              <td>{{ h_i18n('4b123f5f935609529ffab06e9666f0ca') }}</td>
              <td>{{getData.tjnumber}}</td>
              <td>{{ h_i18n('2153e04c74140dd4926dd724aad0d2a7') }}</td>
              <td class="line-td-style">{{getData.sybName}}</td>
            </tr>
            <tr>
              <td>{{ h_i18n('aa7627881ef67231b754e18f903eed6b') }}</td>
              <td colspan="3">
                {{getData.stopReason}}
              </td>
              
            </tr>
            <tr>
              <td>{{ h_i18n('5236d9e96736aa2936cbff9968297317') }}</td>
              <td>{{postData.inputName}}</td>
              <td>{{ h_i18n('25356d67326071b4b6d9db598126ca6c') }}</td>
              <td>{{postData.inputTime}}</td>
            </tr>
            <tr>
              <td><span class="dangerColor">*</span>{{ h_i18n('1adff36d28b18111c04cd459cd26a5e7') }}</td>
              <td class="line-td-style" colspan="3">
                <el-tooltip effect="redTip" placement="top" :disabled="false" :visible="data.appealContentFlag" :content="h_i18n('b79c78d963694a6eea59f441ba8b452a')">
                <div>
                  <el-input class="td-input-style" v-model="postData.appealContent" type="textarea" :rows="3" show-word-limit maxlength="200"></el-input>
                </div>
              </el-tooltip>
              </td>
            </tr>
            <tr>
              <td><span class="dangerColor">*</span>{{ h_i18n('5a0fe6ca084affe7652a5abe2648620c') }}</td>
              <td class="line-td-style" colspan="3">
                <el-tooltip effect="redTip" placement="top" :disabled="false" :visible="data.fileFlag" :content="h_i18n('435d09c3eab65b4b6720390b99327e36')">
                  <hc-file-upload download delete v-model="data.file" accept="all"
                    :info="h_i18n('0a94aa92aebd0d07cd2fffcb3c3b545f')" @error="errorFile" @delete="deleteFun()" @download="download()" @change="fileChange">
                  </hc-file-upload>
              </el-tooltip>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <inspection-footer class="table_footer_style">
      <template #footer>
        <h-button-group align="center">
          <h-button @click="isNull" type="primary" :loading="subLoading">{{ h_i18n('939d5345ad4345dbaabe14798f6ac0f1') }}</h-button> 
          <h-button @click="backBtn" type="primary">{{ h_i18n('5f411223ca5a01a5adf20fe735a433d0') }}</h-button>
        </h-button-group>
      </template>
    </inspection-footer>
  </h-inspection-page>
</template>



<script setup>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

  import {reactive,getCurrentInstance,onMounted, onBeforeMount, nextTick, onUpdated, ref, defineEmit, computed} from "vue";
  import { useRoute } from "vue-router";
  const { proxy, ctx } = getCurrentInstance();
  const route = useRoute();
  const emit = defineEmit(
    ['submit','routerBack']
  )
  const props = defineProps({
    kindType: {
      type: String,
      default: ''
      // sqm申诉 Appeal
    },
    getData: {
      type:Object,
      default: {}
    },
    subLoading:{
      type:Boolean,
      default:false,
    }
  })
  const postData = reactive({
    fileUuid:"",
    fileName:"",
    inputName:"",
    inputTime:proxy.time(new Date())
  })
  const data = reactive({
    title:'',
    appealContentFlag:false,
    flie:{},
    fileFlag:false,
  })

  const isNull = () => {
    if(!postData.appealContent){
      data.appealContentFlag = true
      setTimeout(() => {
        data.appealContentFlag = false
      }, 2000)
      return
    }
    if(!postData.fileUuid || !postData.fileName ){
      data.fileFlag = true
      setTimeout(() => {
        data.fileFlag = false
      }, 2000)
      return
    }
    proxy.info({title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), message: h_i18n('ea26fd0c8e461561f8aca37302a4befb'),confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),cancelButtonText:h_i18n('625fb26b4b3340f7872b411f401e754c'),
      callback: (action) => {
        if(action == 'confirm'){
          emit("submit",postData)
        }
      },
    })   
  }
  const backBtn = () => {
    proxy.info({title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), message: h_i18n('fa8cddd1d9052320cf5dfdeecda0a284'),confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),cancelButtonText:h_i18n('625fb26b4b3340f7872b411f401e754c'),
      callback: (action) => {
        if(action == 'confirm'){
          emit("backBtn")
        }
      },
    })    
  }

  /**
   * h-file-upload 上传文件
   */
  const fileChange = (file) => {
    proxy.startLoading(h_i18n('92cd554eff7896f979917f3ae449b460'))
    let formData = new FormData()
    formData.append('files', file.file)
    proxy.$http({
      method: "POST",
      url: "/base/fileUpload/uploadToOssSaveUrl",
      data: formData
    }).then(res => {
      if (res.data.code === "0") {
        postData.fileUuid = res.data.data
        postData.fileName = file.name
      } else {
        proxy.error(h_i18n('3a845c4dd82bd5a445333dfcbabb4350'))
        data.file = null
      }
    }).catch(err=>{
      proxy.error(h_i18n('3a845c4dd82bd5a445333dfcbabb4350'))
      data.file = null
    }).finally(()=>{
      proxy.closeLoading()
    })
  }
  /**
   * h-file-upload 下载
   */
  const download = () =>{
    proxy.startLoading('下载中...')
    let uid = "/base/fileDownload/downloadFile?filePath="+postData.fileUuid.split('https://sqm.haier.net/readFile/')[1]
    proxy.httpFile({
      method: "get",
      url: uid,
      headers: {'content-type': 'application/json'},
    }, postData.fileName)
  }
  /**
   * h-file-upload 删除
   */
  const deleteFun = () =>{
    postData.fileUuid = ''
    postData.fileName = ''
  }


  onMounted(()=>{
    props.kindType == 'Appeal'  && (data.title = h_i18n('ce6326e846e2c23e9a83fcfb9774685f'))
    if(route.query){
      postData.inputName = route.query.trueName
    }
  })
</script>

<style lang="scss" scoped>
.rejectsStop_reportTable_style{
  .source_style{
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    display: inline-block !important;
    padding-left: 5px;
  }
  .source_style:hover{
    white-space: unset;
    word-break: break-all;
  }
  :deep(.top_wrap_style2){
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  .top_wrap_style2 > div{
    .haier-table{
      .haier-table-header{
        tr{
          td{
            .haier-table-header--right{
              // margin-left: -1px;
              // border-bottom: 1px solid #ccc !important;
              // padding-left: 0px !important;
            }
          }
        }
      }
    }
  }
  .top_style{
    height: 100%;
    width: 100%;
    background: #fff;
    margin-top: 10px;
    .ground_style{
      display: flex;
      background: #f7f8fa;
      width: 100%;
      height: 100%;
      .top_left{
        color: #4E5969;
        font-size: 14px;
        width: 100%;
        background: #fff;
        border-radius: 8px;
        height: 100%;
        padding: 10px;
        .table-box-bordered{
          width: 100%;
          table-layout:fixed;
          font-size: 14px;
          border-left: 1px solid #e9e9e9;
          border-top: 1px solid #e9e9e9;
          background: #fff;
          .top_left_table_title{
            // background: #E8F3FF;
            width: 16%;
          }
          .top_left_table_content{
            width: 34%;
          }
          tr{
            td:nth-child(even){
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            td:nth-child(even):hover{
              white-space: unset;
              word-break: break-all;
              div{
                div{
                  white-space: unset;
                  word-break: break-all;
                }
              }
            }
            td:nth-child(odd){
              text-align: right;
            }
            td:nth-child(odd)::after{
              // content: ':';
            }
          .line-td-style{
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            :deep(.td-input-style){
              padding-top:6.5px;
              padding-bottom:6.5px;
              .el-textarea__inner{
                height: 100%;
              }
            }
          }
          .line-td-style:hover{
            white-space: unset;
            word-break: break-all;
            div{
              div{
                white-space: unset;
                word-break: break-all;
              }
            }
          }
        }
        }
        // 左侧 table 样式
        .table-bordered ,.table-bordered table, .table-bordered th,.table-bordered td{
          border: 1px solid #e9e9e9;
        }
        .table-box-bordered th{
          border-right: 1px solid #e9e9e9;
          border-bottom:1px solid #e9e9e9 ;
        }
        .table-box-bordered td{
          border-right: 1px solid #e9e9e9;
          border-bottom: 1px solid #e9e9e9;
          height: 48px;
          padding: 0 10px;
        }
        .table-box-bordered {
          .title_style{
            text-align: center;
            background: rgb(232, 243, 255);
          }
          .td_wh{
            padding: 5px 10px !important;
            .el-textarea{
              font-size: 14px;
              .el-textarea__inner{
                height: 100% !important;
              }
            }
          }
          .notMold_style{
            padding: 5px 10px !important;
            .el-textarea{
              font-size: 14px;
            .el-textarea__inner{
              height: 100% !important;
            }
          }
          }
        }
      }
      // .top_right{
      //   margin-left: 10px ;
      //   width: 40%;
      //   background: #fff;
      //   border-radius: 8px;
      //   padding: 0 10px;
      //   // height: 100%;
      //   display: flex;
      //   .topright_table{
      //     width: 100%;
      //     height: 100%;
      //     padding: 10px 0;
      //     .haier-inspection-page .el-table th{
      //       background: rgb(232, 243, 255);
      //     }
      //     .el-table{
      //       border-bottom: 0px !important;
      //       border-right: 0px !important;
      //     }
      //   }
      //   .topright_pic{
      //     padding-left: 10px;
      //     padding-top: 10px;
      //     width: 31%;
      //     height: 100%;
      //   }
      // }
    }
  }
  .table_footer_style{
    // margin-top: -10px !important;
    :deep(.haier-table){
      display: none !important;
    }
  }
}
.el-popper.is-red {
  /* Set padding to ensure the height is 32px */
  padding: 6px 12px;
  background: linear-gradient(90deg, rgb(255, 0, 0), rgb(255, 0, 0));
  color: #fff;
}

.el-popper.is-red .el-popper__arrow::before {
  background: linear-gradient(45deg, #ff0000, #ff0000);
  right: 0;
}
</style>